<sc-no-data-container fitHeight [hasData]="this.dataSource.filteredData.length > 0" class="visitor-upfront-registration-list">
  <sc-scroll-pane>
    <table class="mat-table-selection" mat-table [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
      [matSortDirection]="sortDirection">
      <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->

      <ng-container matColumnDef="hint">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.hint"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let visit">
          <span [class]="visit.hintStyle"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.name"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.name}} </td>
      </ng-container>

      <ng-container matColumnDef="firstname">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.firstname"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.firstname}} </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.company"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.company}} </td>
      </ng-container>

      <ng-container matColumnDef="visitedPerson">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.visitedperson"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonString}} </td>
      </ng-container>

      <ng-container matColumnDef="numberPlate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.numberplate"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.numberPlate}} </td>
      </ng-container>

      <ng-container matColumnDef="plannedArrival">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.plannedArrival"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.plannedArrival}} </td>
      </ng-container>

      <ng-container matColumnDef="arrival">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.arrival"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.arrival}} </td>
      </ng-container>

      <ng-container matColumnDef="leave">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.leave"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.leave}} </td>
      </ng-container>

      <ng-container matColumnDef="registrationCode">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.registrationcode"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.registrationCode}} </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc.visitreservation.overview.table.column.role"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.role}} </td>
      </ng-container>

      <ng-container matColumnDef="supplementaryEquipments">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.supplementaryEquipments"></sc-dictionary-label>
        </th>
        <td mat-cell class="multiple-lines text-selection" *matCellDef="let visit"> {{visit.supplementaryEquipments}} </td>
      </ng-container>

      <ng-container matColumnDef="invitationSentDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.invitationSentDate"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.invitationSentDate}}</td>
      </ng-container>

      <ng-container matColumnDef="lastTerminalRegistrationDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.lastTerminalRegistrationDate"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastTerminalRegistrationDate}}</td>
      </ng-container>

      <ng-container matColumnDef="lastClientRegistrationDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.lastClientRegistrationDate"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastClientRegistrationDate}}</td>
      </ng-container>

	  <ng-container matColumnDef="visitEnd">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitEnd'|
          translate:['tmc-visit.entity.visit.visitEnd', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitEnd}}</td>
      </ng-container>

      <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let visit"></td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let visit; columns: columnsToDisplay" [ngClass]="getRowStyles(visit)"
        (click)="toggleSelection(visit)"></tr>

    </table>
  </sc-scroll-pane>
</sc-no-data-container>
